export const membersRoute = () => import("../pages/dashboard/members/page");
export const memberRoute = () => import("../pages/dashboard/member/page");
export const clientsRoute = () => import("../pages/dashboard/clients/page");
export const clientRoute = () => import("../pages/dashboard/client/page");
export const assignmentsRoute = () => import("../pages/dashboard/assignments/page");
